'use client'

import type { FormImageListUploadInputProps, FormType } from '../../types/types'
import { useFieldArray, useFormContext } from "react-hook-form"

import { FormField } from "../FormField/FormField"
import { FormImageUpload } from "./FormImageUpload"
import { HStack } from "@chakra-ui/react"
import { useEffect } from "react"

const FormImageListUpload = <T extends FormType>({
	name,
  maxFields,
  aspectRatio,
	label,
	helperText,
	optionalText,
	isRequired,
	_formField,
  ...stackProps
}: FormImageListUploadInputProps<T>) => {
  const  { control, getValues, setValue, formState: { defaultValues }  } = useFormContext();
  const { fields }    = useFieldArray({
    control,
    name,
  })


  useEffect(() => {
    const currentValue = defaultValues?.[name] as any[]
    const paddedDefaultValue 
      = Array.from({ length: maxFields }, (_, index) => currentValue?.[index] || undefined)
    setValue(name, paddedDefaultValue as never)
  }, [])

  return (
    <FormField
      helperText={helperText}
      label={label}
      name={name}
      optionalText={optionalText}
      required={isRequired}
      {..._formField}
    >
      <HStack w='100%' gap={4} {...stackProps}>
        {fields.map((field, index) => (
          <FormImageUpload
            key={field.id}
            aspectRatio={aspectRatio}
            w='100%'
            name={`${name}.${index}`}
          />
        ))}
      </HStack>
    </FormField>
  )
}

export default FormImageListUpload